import React, { useEffect } from 'react';

const PartnerPortalPage = () => {
  useEffect(() => {
    // Doğrudan Tourzone partner login sayfasına yönlendir
    window.location.href = 'https://partners.tourzone.com/Login';
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '60vh',
      flexDirection: 'column',
      gap: '16px'
    }}>
      <div style={{ fontSize: '18px', color: '#666' }}>
        Yönlendiriliyor...
      </div>
      <div style={{ fontSize: '14px', color: '#999' }}>
        Tourzone İş Ortağı Portalı'na yönlendiriliyorsunuz
      </div>
    </div>
  );
};

export default PartnerPortalPage;

